import { createAsyncThunk } from '@reduxjs/toolkit'
import { getStocksByType } from '@services'
import { StockDistributionResponse, StockDistributionTypes } from '@interfaces'

export const fetchStockDistribution = createAsyncThunk<
  StockDistributionResponse,
  StockDistributionTypes
>('fetchStockDistribution', (groupingType: StockDistributionTypes) =>
  getStocksByType(groupingType),
)
